import { ComponentProps } from "react";

export default function Link({
  target = "_blank",
  rel = "noreferrer noopener",
  children,
  ...props
}: ComponentProps<"a">) {
  return (
    <a target={target} rel={rel} {...props}>
      {children}
    </a>
  );
}
